import "./ProductDetail.css";
import  { useContext, useEffect } from "react";
import SelectedPackageBanner from "../SelectedPackageBanner/SelectedPackageBanner";
import claroMusica from "../../assets/claroMusica.svg";
import twitterIconGray from "../../assets/twitterIconGray.svg";
import facebookIconGray from "../../assets/facebookIconGray.svg";
import whatsappIconGray from "../../assets/whatsappIconGray.svg";
import messengerIconGray from "../../assets/messengerIconGray.svg";
import snapchatIconGray from "../../assets/snapchatIconGray.svg";
import instagramIconGray from "../../assets/instagramIconGray.svg";

import { DETAILS_POPUP,  } from "../../constants/callTrackingConstants";
import AppContext from "../../AppContext";
import PropTypes from 'prop-types';


const ProductDetail = ({ product }) => {
  const { doCallTracking, number } = useContext(AppContext);

  const {
    title,
    pkgClaroMusic,
    pkgInternetMb,
    pkgMinutesSms,
    pkgWhatsapp,
    pkgFbMsn,
    pkgTwitter,
    pkgFb,
    pkgSnapchat,
    pkgInstagram,
    pkgMessagingMb,
    pkgSocialNetMb,
    pkgValidity,
    amount,
    pkgType
  } = product;

  useEffect(()=>{
    doCallTracking(
      `${DETAILS_POPUP.IMPRESION.elementName}`,
      `${DETAILS_POPUP.IMPRESION.elementLocation}${pkgType}`,
      number
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  return (
    <div className="container__product__detail">
      <p className="detail__title">Detalles del Producto</p>
      <div className="selected__package__conteiner">
        <SelectedPackageBanner product={product} />
        <p className="detail__package__title">{title}</p>
      </div>

      {pkgClaroMusic && (
        <div className="claro__musica__benefit__container">
          <div className="claro__musica">
            <img src={claroMusica} alt="claro-musica" />
            <p className="claro__musica__title">
              Incluye 500 MB para navegar en la App
            </p>{" "}
          </div>
        </div>
      )}

      <div className="benefits__container">
        {pkgInternetMb && (
          <div className="benefit__information__card">
            <p className="benefit__quantity__text">
              {pkgInternetMb.split(" ")[0]}
            </p>
            <p className="benefit__information__text">
              {`${
                pkgInternetMb.split(" ")[1] ? pkgInternetMb.split(" ")[1] : "GB"
              } incluidos`}
            </p>
            <p className="benefit__places__text">México / E.U.A. / Canadá*</p>
          </div>
        )}
        {pkgMinutesSms && (
          <div className="benefit__information__card">
            <p className="benefit__quantity__text">{pkgMinutesSms}</p>
            <p className="benefit__information__text">
              Minutos y SMS Sin Frontera
            </p>
            <p className="benefit__places__text">México / E.U.A. / Canadá</p>
          </div>
        )}

        {pkgMessagingMb && (
          <div className="benefit__information__card">
            <p className="benefit__quantity__text">{pkgMessagingMb}</p>
            <p className="benefit__information__text">
              Mensajería Sin Frontera
            </p>
            <p className="benefit__places__text">México / E.U.A. / Canadá</p>
            <div>
              {pkgWhatsapp && (
                <img
                  src={whatsappIconGray}
                  alt="whatsapp-icon-gray"
                  width={"16px"}
                />
              )}
            </div>
          </div>
        )}

        {pkgSocialNetMb && (
          <div className="benefit__information__card">
            <p className="benefit__quantity__text">{pkgSocialNetMb}</p>
            <p className="benefit__information__text">
              Redes Sociales Nacionales
            </p>
            <p className="benefit__places__text">México</p>
            <div className="container__detail__icons">
              {pkgFb && (
                <img
                  src={facebookIconGray}
                  alt="facebook-icon-gray"
                  width={"16px"}
                  height={"16px"}
                />
              )}
              {pkgTwitter && (
                <img
                  src={twitterIconGray}
                  alt="twitter-icon-gray"
                  width={"16px"}
                />
              )}
              {pkgFbMsn && (
                <img
                  src={messengerIconGray}
                  alt="messenger-icon-gray"
                  width={"16px"}
                />
              )}
              {pkgWhatsapp && (
                <img
                  src={whatsappIconGray}
                  alt="whatsapp-icon-gray"
                  width={"16px"}
                />
              )}
              {pkgSnapchat && (
                <img
                  src={snapchatIconGray}
                  alt="snapchat-icon-gray"
                  width={"16px"}
                />
              )}
              {pkgInstagram && (
                <img
                  src={instagramIconGray}
                  alt="instagram-icon-gray"
                  width={"16px"}
                />
              )}
            </div>
          </div>
        )}

        <div className="benefit__information__card">
          <p className="benefit__quantity__text">{pkgValidity}</p>
          <p className="benefit__information__text">Vigencia</p>
        </div>

        <div className="benefit__information__card">
          <p className="benefit__quantity__text">{`$${amount}`}</p>
          <p className="benefit__information__text">Costo</p>
        </div>
      </div>
    </div>
  );
};

ProductDetail.propTypes = {
  product: PropTypes.object,
};

export default (ProductDetail);
